let currentListTooltip = null;

const isMobile = window.innerWidth < 768;
const marquee = document.querySelector('.award-marquee-track');

// Clone nội dung marquee để tạo hiệu ứng lặp
const originalContent = marquee.innerHTML;
marquee.innerHTML += originalContent;

let scrollAmount = 0;

function animateMarquee() {
  if (!marquee.classList.contains('paused')) {
    scrollAmount += 0.5;
    if (scrollAmount >= marquee.scrollWidth / 2) {
      scrollAmount = 0;
    }
    marquee.style.transform = `translateX(-${scrollAmount}px)`;
  }
  requestAnimationFrame(animateMarquee);
}

animateMarquee();

function showListTooltip(item, info) {
  removeListTooltip();

  const tooltip = document.createElement('div');
  tooltip.className = 'award-tooltip';
  tooltip.innerHTML = `
    <div class="tooltip-inner">${info}</div>
    <div class="tooltip-arrow"></div>
    ${isMobile ? '<button class="tooltip-close" aria-label="Close tooltip">&times;</button>' : ''}
  `;

  document.body.appendChild(tooltip);
  currentListTooltip = tooltip;

  const rect = item.getBoundingClientRect();
  const tooltipHeight = tooltip.offsetHeight;

  tooltip.style.position = 'absolute';
  tooltip.style.left = `${rect.left + window.scrollX + rect.width / 2}px`;
  tooltip.style.top = `${rect.top + window.scrollY - tooltipHeight - 10}px`;
  tooltip.style.transform = 'translateX(-50%)';
  tooltip.style.zIndex = 9999;
  tooltip.style.pointerEvents = 'auto';

  marquee.classList.add('paused');

  if (isMobile) {
    const btnClose = tooltip.querySelector('.tooltip-close');
    if (btnClose) {
      btnClose.addEventListener('click', (e) => {
        e.stopPropagation();
        console.log('Close button clicked');
        removeListTooltip();
      });
    }
  }
}

function removeListTooltip() {
  console.log('removeListTooltip called', currentListTooltip);
  if (currentListTooltip) {
    currentListTooltip.remove();
    currentListTooltip = null;
    marquee.classList.remove('paused');
    console.log('Tooltip removed');
  }
}

// Event delegation cho hover/click trên marquee
if (!isMobile) {
  // hover cho desktop
  marquee.addEventListener('mouseover', (e) => {
    const item = e.target.closest('.list-item');
    if (!item) return;
    const info = item.getAttribute('data-info');
    showListTooltip(item, info);
  });

  marquee.addEventListener('mouseout', (e) => {
    const item = e.target.closest('.list-item');
    if (!item) return;
    removeListTooltip();
  });
} else {
  // click cho mobile
  marquee.addEventListener('click', (e) => {
    const item = e.target.closest('.list-item');
    if (!item) return;
    e.stopPropagation();
    const info = item.getAttribute('data-info');
    showListTooltip(item, info);
  });

  // Click ngoài tooltip ẩn tooltip
  document.body.addEventListener('click', (e) => {
    if (currentListTooltip && !currentListTooltip.contains(e.target)) {
      removeListTooltip();
    }
  });
}
